import React from 'react';
import Page from 'App/components/Page';
import './AssignmentManagerPage.scss';
import { PERMISSION_TYPES } from 'App/utils/isPermitted/isPermitted';
import { AssignmentMainSection } from './Components/AssignmentMainSection';
import { QueueProvider } from '../WorkQueue/QueueProvider';
import useIsPermitted from 'App/utils/hooks/useIsPermitted';
import { NotFound } from 'App/components/errors';
import ActivityCount from '../WorkQueue/components/ActivityCount';
import MyFilters from '../WorkQueue/components/MyFilters';
import WorkQueueFilters from '../WorkQueue/components/WorkQueueFilters';
import { FILTER_TYPE } from '../WorkQueue/workQueue.constant';

export const AssignmentManagerPage = () => {
    const isAssignmentManager = useIsPermitted(PERMISSION_TYPES.ASSIGNMENT_MANAGER);

    if (isAssignmentManager) {
        return (
            <div className="assignment-manager">
                <QueueProvider filterType={FILTER_TYPE.ASSIGNMENT_MANAGER}>
                    <aside>
                        <ActivityCount />
                        <MyFilters />
                        <WorkQueueFilters />
                    </aside>
                    <article>
                        <Page title="Assignment Manager" showPageTitle>
                            <AssignmentMainSection />
                        </Page>
                    </article>
                </QueueProvider>
            </div>
        );
    }
    return <NotFound />;
};

export default AssignmentManagerPage;
